import dayjs from "dayjs";
import { isArray } from "lodash";
import "./merchant";

export const getResponseData = (data, total) => {
  return {
    data: data,
    statusCode: 200,
    time: dayjs().toISOString(),
    total: total ? total : isArray(data) ? data.length : 0,
  };
};
